// extracted by mini-css-extract-plugin
module.exports = {"router":"App_router__s7h9k","containedInIFrame":"App_containedInIFrame__36ZK9"};